export const B2BRewardsSpec = `openapi: 3.0.1
info:
  title: Reward Engine
  description: Simple and Fast Reward Engine
  version: "1.2"
servers:
- url: http://localhost:8080
  description: Generated server url
security:
- oktaOAuth: []
tags:
- name: Default
  description: API endpoints for basic health checks and test routes
- name: Template Download
  description: API endpoints for downloading various CSV templates
- name: Rewards
  description: APIs for managing rewards and reward catalog
- name: Goal Configuration V2
  description: V2 APIs for managing goal configurations with enhanced image validation
    requirements
- name: Reports
  description: API endpoints for generating and downloading reports
- name: Activity Names
  description: API endpoints for retrieving activity names by country
- name: OMS Integration
  description: API endpoints for Order Management System integration and points estimation
- name: User Segments
  description: API endpoints for managing user segments and segment-based operations
- name: Activity Logs
  description: API endpoints for managing activity logs and retrieving activity master
    data
- name: Points Automation
  description: APIs for managing automated points distribution
- name: Dropdown Master
  description: API endpoints for retrieving dropdown values for various form fields
- name: Tiers
  description: "API endpoints for managing tier configurations, stores, and tier-related\
    \ operations"
- name: Activity Configuration
  description: APIs for managing activity configurations
- name: File Metadata
  description: API endpoints for managing file metadata information
- name: Tier Images
  description: API endpoints for uploading and managing tier-related images
- name: User Goals
  description: APIs for managing user goals and targets
- name: ERP Category Mapping
  description: API endpoints for managing CEP Product IDs to ERP category mappings
- name: Activity Master
  description: API endpoints for managing activity master data
- name: User Activities
  description: API endpoints for managing user activity tracking and reporting
- name: Reward Engine User
  description: APIs for managing reward engine users
- name: Activity Types
  description: API endpoints for retrieving activity type enumerations
- name: Points Multiplier
  description: API endpoints for managing points multiplier configurations
- name: Application Management
  description: APIs for managing applications and order processing
- name: Public Files
  description: API endpoints for accessing publicly available files
- name: Goals
  description: APIs for managing goals and sales targets
- name: File Share
  description: "API endpoints for file upload, download and sharing operations"
paths:
  /v2/goals/{id}:
    put:
      tags:
      - Goal Configuration V2
      summary: Update goal with image validation
      description: Updates an existing goal configuration with enhanced image validation
        requirements
      operationId: updateGoal
      parameters:
      - name: id
        in: path
        description: Goal ID to update
        required: true
        schema:
          type: integer
          format: int32
      requestBody:
        content:
          application/json:
            schema:
              $ref: '#/components/schemas/UpdateGoalDto'
        required: true
      responses:
        "400":
          description: Invalid goal data or missing required images
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Goal not found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "500":
          description: Internal server error
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Goal updated successfully
          content:
            '*/*':
              schema:
                type: object
  /v1/users/{storeId}:
    put:
      tags:
      - Reward Engine User
      summary: Update User Details
      description: Updates user details for the given store ID
      operationId: updateRewardEngineUser
      parameters:
      - name: storeId
        in: path
        description: Store ID of the user to update
        required: true
        schema:
          type: string
      requestBody:
        content:
          application/json:
            schema:
              $ref: '#/components/schemas/UpdateRewardEngineUserDto'
        required: true
      responses:
        "400":
          description: Bad Request
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Successfully updated user
          content:
            '*/*':
              schema:
                type: object
  /v1/users/{storeId}/goals:
    get:
      tags:
      - User Goals
      summary: Fetch User Goals
      description: Retrieves user goals for a specific store with pagination
      operationId: fetchUserGoal
      parameters:
      - name: storeId
        in: path
        description: Store ID to fetch goals for
        required: true
        schema:
          type: string
      - name: body
        in: query
        description: Request parameters for goal filtering
        required: true
        schema:
          $ref: '#/components/schemas/GetUserGoalRequestDto'
      responses:
        "400":
          description: Invalid request parameters
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Store not found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Successfully retrieved user goals
          content:
            '*/*':
              schema:
                type: object
    put:
      tags:
      - User Goals
      summary: Update User Goals
      description: Updates user goals for a specific store
      operationId: updateUserGoal
      parameters:
      - name: storeId
        in: path
        description: Store ID to update goals for
        required: true
        schema:
          type: string
      requestBody:
        content:
          application/json:
            schema:
              $ref: '#/components/schemas/UserGoalUpdateRequestDto'
        required: true
      responses:
        "400":
          description: Invalid update data
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Store or goals not found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: User goals updated successfully
          content:
            '*/*':
              schema:
                type: object
  /v1/rewards:
    get:
      tags:
      - Rewards
      summary: Get Reward Catalog
      description: Retrieves the complete list of rewards catalog with pagination
      operationId: getRewardCatalog
      parameters:
      - name: requestDto
        in: query
        description: Request parameters for catalog filtering and pagination
        required: true
        schema:
          $ref: '#/components/schemas/RewardCatalogRequestDto'
      responses:
        "400":
          description: Invalid request parameters
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Successfully retrieved reward catalog
          content:
            '*/*':
              schema:
                $ref: '#/components/schemas/RewardCatalogResponseDtoRewardCatalogItemDto'
    put:
      tags:
      - Rewards
      operationId: update
      requestBody:
        content:
          application/json:
            schema:
              $ref: '#/components/schemas/CreateRewardDto'
        required: true
      responses:
        "400":
          description: Bad Request
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: OK
          content:
            '*/*':
              schema:
                $ref: '#/components/schemas/ViewRewardDto'
    post:
      tags:
      - Rewards
      summary: Create New Reward
      description: Creates a new reward with the provided details
      operationId: create_2
      requestBody:
        content:
          application/json:
            schema:
              $ref: '#/components/schemas/CreateRewardDto'
        required: true
      responses:
        "400":
          description: Invalid reward data
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "201":
          description: Reward created successfully
          content:
            '*/*':
              schema:
                $ref: '#/components/schemas/ViewRewardDto'
  /v1/points-automation/{id}:
    put:
      tags:
      - Points Automation
      summary: Update config
      description: Updates an existing points automation configuration
      operationId: update_1
      parameters:
      - name: id
        in: path
        description: ID of the points automation to update
        required: true
        schema:
          type: integer
          format: int32
      requestBody:
        content:
          application/json:
            schema:
              $ref: '#/components/schemas/UpdatePointAutomationDto'
        required: true
      responses:
        "400":
          description: Invalid automation data
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Points automation not found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Points automation updated successfully
          content:
            '*/*':
              schema:
                type: object
  /v1/goals/{id}:
    get:
      tags:
      - Goals
      summary: Fetch goal configuration by ID
      description: Retrieves a specific goal configuration by its ID
      operationId: fetchGoalConfigById
      parameters:
      - name: id
        in: path
        description: Goal ID to retrieve
        required: true
        schema:
          type: integer
          format: int32
      - name: params
        in: query
        description: Additional request parameters
        required: true
        schema:
          $ref: '#/components/schemas/GoalConfigByIdRequestListingDto'
      responses:
        "400":
          description: Invalid goal ID
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Goal not found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Goal configuration retrieved successfully
          content:
            '*/*':
              schema:
                type: object
        "500":
          description: Internal server error
          content:
            '*/*':
              schema:
                type: object
    put:
      tags:
      - Goals
      summary: Update Goal
      description: Updates an existing goal configuration by ID
      operationId: updateGoal_1
      parameters:
      - name: id
        in: path
        description: Goal ID to update
        required: true
        schema:
          type: integer
          format: int32
      requestBody:
        content:
          application/json:
            schema:
              $ref: '#/components/schemas/UpdateGoalDto'
        required: true
      responses:
        "400":
          description: Invalid goal data provided
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Goal not found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "500":
          description: Internal server error
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Goal updated successfully
          content:
            '*/*':
              schema:
                type: object
  /v1/goals/{id}/import-file:
    put:
      tags:
      - Goals
      summary: Update user goals import file
      description: Updates user goals using an import file for the specified goal
        configuration
      operationId: updateUserGoals
      parameters:
      - name: id
        in: path
        description: Goal configuration ID to update
        required: true
        schema:
          type: integer
          format: int32
      requestBody:
        content:
          application/json:
            schema:
              $ref: '#/components/schemas/UpdateImportFileRequestDto'
        required: true
      responses:
        "400":
          description: Invalid import file data
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Goal configuration not found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: User goals import queued successfully
          content:
            '*/*':
              schema:
                type: object
        "500":
          description: Internal server error
          content:
            '*/*':
              schema:
                type: object
  /v1/application/{applicationId}:
    get:
      tags:
      - Application Management
      summary: Get an application
      description: Gets Rewards engine application for a country by ID
      operationId: get
      parameters:
      - name: applicationId
        in: path
        description: Application ID
        required: true
        schema:
          type: integer
          format: int32
      responses:
        "400":
          description: Bad Request
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Successfully retrieved application
          content:
            '*/*':
              schema:
                type: object
    put:
      tags:
      - Application Management
      summary: Update an application
      description: Updates application configuration and rules
      operationId: update_2
      parameters:
      - name: applicationId
        in: path
        description: Application ID
        required: true
        schema:
          type: integer
          format: int32
      requestBody:
        content:
          application/json:
            schema:
              $ref: '#/components/schemas/UpdateApplicationDto'
        required: true
      responses:
        "400":
          description: Bad Request
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Validation Error
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Successfully updated application
          content:
            '*/*':
              schema:
                type: object
  /v1/activities/{id}:
    put:
      tags:
      - Activity Configuration
      summary: Update activity config
      description: Updates an existing activity configuration by ID
      operationId: update_3
      parameters:
      - name: id
        in: path
        description: ID of the activity configuration to update
        required: true
        schema:
          type: integer
          format: int32
      requestBody:
        content:
          application/json:
            schema:
              $ref: '#/components/schemas/UpdateActivityConfigDto'
        required: true
      responses:
        "400":
          description: Bad Request
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Validation Error
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Successfully updated activity configuration
          content:
            '*/*':
              schema:
                type: object
  /v2/goals:
    post:
      tags:
      - Goal Configuration V2
      summary: Create goals with image validation
      description: Creates new goal configuration with enhanced image validation requirements
        including foreground image validation
      operationId: createGoals
      requestBody:
        content:
          application/json:
            schema:
              $ref: '#/components/schemas/GoalDto'
        required: true
      responses:
        "400":
          description: Invalid goal data or missing required images
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Referenced record not found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Goals created successfully
          content:
            '*/*':
              schema:
                type: object
        "500":
          description: Internal server error
          content:
            '*/*':
              schema:
                type: object
  /v1/users:
    get:
      tags:
      - Reward Engine User
      summary: Get User Details
      description: Retrieve users with pagination and filtering
      operationId: getUsers
      parameters:
      - name: params
        in: query
        description: Listing parameters for filtering and pagination
        required: true
        schema:
          $ref: '#/components/schemas/RewardEngineUserListingDto'
      responses:
        "400":
          description: Bad Request
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Successfully retrieved users
          content:
            '*/*':
              schema:
                type: object
    post:
      tags:
      - Reward Engine User
      summary: Create Reward Engine User
      description: Creates reward engine user for given store ID and app-ID
      operationId: createRewardEngineUser
      requestBody:
        content:
          application/json:
            schema:
              $ref: '#/components/schemas/RewardEngineUserDto'
        required: true
      responses:
        "400":
          description: Bad Request
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Successfully created user
          content:
            '*/*':
              schema:
                type: object
  /v1/users/{storeId}/segments:
    post:
      tags:
      - User Segments
      summary: Create user segment for store
      description: Creates a new user segment configuration for a specific store
      operationId: create
      parameters:
      - name: storeId
        in: path
        description: Store ID to create segment for
        required: true
        schema:
          type: string
      requestBody:
        content:
          application/json:
            schema:
              $ref: '#/components/schemas/UpdateUserSegmentsDto'
        required: true
      responses:
        "400":
          description: Invalid segment data
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: User segment created successfully
          content:
            '*/*':
              schema:
                type: object
        "500":
          description: Internal server error
          content:
            '*/*':
              schema:
                type: object
  /v1/users/{storeId}/activities:
    post:
      tags:
      - User Activities
      summary: Perform/create new activity
      description: Creates or performs a new user activity for the specified store
      operationId: create_1
      parameters:
      - name: storeId
        in: path
        description: Store ID where the activity occurred
        required: true
        schema:
          type: string
      requestBody:
        content:
          application/json:
            schema:
              $ref: '#/components/schemas/CreateUserActivityDto'
        required: true
      responses:
        "400":
          description: Bad Request
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Invalid activity data
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: User activity created successfully
          content:
            '*/*':
              schema:
                type: object
        "500":
          description: Internal server error
          content:
            '*/*':
              schema:
                type: object
  /v1/users/segments:
    get:
      tags:
      - User Segments
      summary: Get unique user segments
      description: Retrieves unique user segments based on rules criteria
      operationId: getUniqueSegments
      parameters:
      - name: userSegmentsRequestDto
        in: query
        description: User segments request parameters for filtering
        required: true
        schema:
          $ref: '#/components/schemas/UserSegmentsRequestDto'
      responses:
        "400":
          description: Invalid request parameters
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "500":
          description: Internal server error
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: User segments retrieved successfully
          content:
            '*/*':
              schema:
                type: object
    post:
      tags:
      - User Segments
      summary: Bulk create user segments
      description: Creates multiple user segment configurations in a single request
      operationId: bulkCreate
      requestBody:
        content:
          application/json:
            schema:
              $ref: '#/components/schemas/UpdateMultipleUserSegmentsDto'
        required: true
      responses:
        "400":
          description: Invalid segment data
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "500":
          description: Internal server error
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: User segments created successfully
          content:
            '*/*':
              schema:
                type: object
  /v1/tiers:
    get:
      tags:
      - Tiers
      summary: Get tier details
      description: "Retrieves tier details based on active status, configuration status,\
        \ and country"
      operationId: getActiveTiers
      parameters:
      - name: country
        in: header
        description: Country code in ISO 3166-1 alpha-2 format
        required: true
        schema:
          pattern: "^[A-Z]{2}$"
          type: string
          default: MX
      - name: active
        in: query
        description: Filter by active status
        required: false
        schema:
          type: boolean
      - name: status
        in: query
        description: Filter by tier configuration status
        required: false
        schema:
          type: string
          enum:
          - PUBLISHED
          - DRAFT
      - name: tierId
        in: query
        description: Filter by specific tier ID
        required: false
        schema:
          type: integer
          format: int32
      responses:
        "400":
          description: Invalid request parameters
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Tiers not found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "204":
          description: No tiers found matching criteria
          content:
            '*/*':
              schema:
                type: array
                items:
                  $ref: '#/components/schemas/TierGetResponse'
        "200":
          description: Tier details retrieved successfully
          content:
            '*/*':
              schema:
                type: array
                items:
                  $ref: '#/components/schemas/TierGetResponse'
        "500":
          description: Internal server error
          content:
            '*/*':
              schema:
                type: array
                items:
                  $ref: '#/components/schemas/TierGetResponse'
    post:
      tags:
      - Tiers
      summary: Create or update tier configuration
      description: Creates a new tier configuration or updates an existing one
      operationId: upsertTierConfig
      parameters:
      - name: country
        in: header
        description: Country code in ISO 3166-1 alpha-2 format
        required: true
        schema:
          pattern: "^[A-Z]{2}$"
          type: string
      requestBody:
        content:
          application/json:
            schema:
              $ref: '#/components/schemas/TierRequest'
        required: true
      responses:
        "400":
          description: Invalid tier configuration data
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "500":
          description: Internal server error
          content:
            '*/*':
              schema:
                $ref: '#/components/schemas/TierPostResponse'
        "201":
          description: Tier configuration created/updated successfully
          content:
            '*/*':
              schema:
                $ref: '#/components/schemas/TierPostResponse'
  /v1/tiers/{tierID}/move-stores:
    post:
      tags:
      - Tiers
      summary: Move stores between tiers
      description: Moves multiple stores from one tier to another
      operationId: moveStores
      parameters:
      - name: country
        in: header
        required: true
        schema:
          pattern: "^[A-Z]{2}$"
          type: string
      - name: tierID
        in: path
        required: true
        schema:
          minimum: 1
          type: integer
          format: int32
      requestBody:
        content:
          application/json:
            schema:
              $ref: '#/components/schemas/MoveStoresRequest'
        required: true
      responses:
        "400":
          description: Invalid request or same tier IDs
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Tier not found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Validation error
          content:
            '*/*':
              schema:
                type: object
        "500":
          description: Internal server error
          content:
            '*/*':
              schema:
                $ref: '#/components/schemas/TiersStoresUpdateResponseDto'
        "201":
          description: Stores moved successfully
          content:
            '*/*':
              schema:
                $ref: '#/components/schemas/TiersStoresUpdateResponseDto'
  /v1/tiers/upload-stores:
    post:
      tags:
      - Tiers
      summary: Upload stores to tier
      description: Uploads multiple stores to a specific tier configuration
      operationId: postTierStores
      parameters:
      - name: country
        in: header
        description: Country code in ISO 3166-1 alpha-2 format
        required: true
        schema:
          pattern: "^[A-Z]{2}$"
          type: string
      requestBody:
        content:
          application/json:
            schema:
              $ref: '#/components/schemas/TiersStoreRequestDto'
        required: true
      responses:
        "400":
          description: Invalid request data
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Tier not found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "500":
          description: Internal server error
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Stores uploaded successfully
          content:
            '*/*':
              schema:
                type: object
  /v1/tiers/image:
    post:
      tags:
      - Tier Images
      summary: Upload tier image
      description: Uploads an image file for tier configurations (temporary solution)
      operationId: uploadImages
      requestBody:
        content:
          application/json:
            schema:
              required:
              - image
              type: object
              properties:
                image:
                  type: string
                  description: Image file to upload for tier configuration
                  format: binary
        required: true
      responses:
        "400":
          description: Empty file or invalid image data
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Image uploaded successfully
          content:
            '*/*':
              schema:
                type: object
                additionalProperties:
                  type: object
        "500":
          description: Internal server error during upload
          content:
            '*/*':
              schema:
                type: object
                additionalProperties:
                  type: object
  /v1/template/download:
    post:
      tags:
      - Template Download
      summary: Download CSV template
      description: Downloads a CSV template file based on the specified template type
        and parameters
      operationId: download
      requestBody:
        content:
          application/json:
            schema:
              $ref: '#/components/schemas/TemplateDownloadParams'
        required: true
      responses:
        "400":
          description: Invalid template parameters
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Template downloaded successfully
          content:
            '*/*':
              schema:
                type: object
        "500":
          description: Error generating template file
          content:
            '*/*':
              schema:
                type: object
  /v1/points-multiplier:
    get:
      tags:
      - Points Multiplier
      summary: List points multipliers
      description: Retrieves a paginated list of points multiplier configurations
      operationId: list
      parameters:
      - name: params
        in: query
        description: Listing parameters for filtering and pagination
        required: true
        schema:
          $ref: '#/components/schemas/ListPointMultiplierRequestDto'
      responses:
        "400":
          description: Invalid request parameters
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Points multipliers retrieved successfully
          content:
            '*/*':
              schema:
                type: object
        "500":
          description: Internal server error
          content:
            '*/*':
              schema:
                type: object
    post:
      tags:
      - Points Multiplier
      summary: Create points multiplier
      description: Creates a new points multiplier configuration
      operationId: create_3
      requestBody:
        content:
          application/json:
            schema:
              $ref: '#/components/schemas/CreatePointMultiplierDto'
        required: true
      responses:
        "400":
          description: Invalid points multiplier data
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Referenced record not found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "500":
          description: Internal server error
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Points multiplier created successfully
          content:
            '*/*':
              schema:
                type: object
  /v1/points-multiplier/validate-name:
    post:
      tags:
      - Points Multiplier
      operationId: validateName
      requestBody:
        content:
          application/json:
            schema:
              $ref: '#/components/schemas/NameValidationRequestDto'
        required: true
      responses:
        "400":
          description: Bad Request
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: OK
          content:
            '*/*':
              schema:
                type: object
  /v1/points-automation:
    get:
      tags:
      - Points Automation
      summary: List config
      description: Retrieves a paginated list of points automation configurations
      operationId: list_1
      parameters:
      - name: params
        in: query
        description: Listing parameters for filtering and pagination
        required: true
        schema:
          $ref: '#/components/schemas/PointAutomationListingParamsDto'
      responses:
        "400":
          description: Bad Request
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Successfully retrieved configurations
          content:
            '*/*':
              schema:
                type: object
    post:
      tags:
      - Points Automation
      summary: Create config
      description: Creates a new points automation configuration
      operationId: create_4
      requestBody:
        content:
          application/json:
            schema:
              $ref: '#/components/schemas/CreatePointAutomationDto'
        required: true
      responses:
        "400":
          description: Invalid automation data
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "201":
          description: Points automation created successfully
          content:
            '*/*':
              schema:
                type: object
  /v1/points-automation/validate-name:
    post:
      tags:
      - Points Automation
      operationId: validateName_1
      requestBody:
        content:
          application/json:
            schema:
              $ref: '#/components/schemas/NameValidationRequestDto'
        required: true
      responses:
        "400":
          description: Bad Request
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: OK
          content:
            '*/*':
              schema:
                type: object
  /v1/oms/estimate-points:
    post:
      tags:
      - OMS Integration
      summary: Estimate points for order
      description: Calculates estimated points for an order based on the provided
        data
      operationId: create_5
      parameters:
      - name: applicationId
        in: query
        description: "Application ID (optional, uses default if not provided)"
        required: false
        schema:
          type: integer
          format: int32
      requestBody:
        content:
          application/json:
            schema:
              $ref: '#/components/schemas/EstimatePointsRequestDto'
        required: true
      responses:
        "400":
          description: Invalid request data
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "500":
          description: Internal server error
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Points estimated successfully
          content:
            '*/*':
              schema:
                type: object
  /v1/goals:
    get:
      tags:
      - Goals
      summary: Retrieve goals
      description: Get goals with pagination and filtering
      operationId: fetchGoalConfig
      parameters:
      - name: params
        in: query
        description: Goal configuration request parameters
        required: true
        schema:
          $ref: '#/components/schemas/GoalConfigRequestListingDto'
      responses:
        "400":
          description: Invalid request parameters
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Application not found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "500":
          description: Internal server error
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Goal configurations retrieved successfully
          content:
            '*/*':
              schema:
                type: object
    post:
      tags:
      - Goals
      summary: Create New Goal
      description: Creates a new sales target or goal
      operationId: createGoals_1
      requestBody:
        content:
          application/json:
            schema:
              $ref: '#/components/schemas/GoalDto'
        required: true
      responses:
        "400":
          description: Invalid goal data provided
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Referenced record not found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Goals created successfully
          content:
            '*/*':
              schema:
                type: object
        "500":
          description: Internal server error
          content:
            '*/*':
              schema:
                type: object
  /v1/fileshare/upload/{type}:
    post:
      tags:
      - File Share
      summary: Upload file
      description: Uploads a file to the server under the specified type directory
      operationId: uploadFile
      parameters:
      - name: type
        in: path
        description: "Type of upload directory (e.g., public, templates, etc.)"
        required: true
        schema:
          type: string
      requestBody:
        content:
          application/json:
            schema:
              required:
              - files
              type: object
              properties:
                files:
                  type: string
                  description: "File to upload (supported formats: jpg, jpeg, png,\
                    \ csv, webp)"
                  format: binary
        required: true
      responses:
        "400":
          description: Invalid file type or empty file
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: File uploaded successfully
          content:
            '*/*':
              schema:
                type: object
                additionalProperties:
                  type: object
        "500":
          description: Internal server error during upload
          content:
            '*/*':
              schema:
                type: object
                additionalProperties:
                  type: object
  /v1/file-metadata:
    post:
      tags:
      - File Metadata
      summary: Create file metadata
      description: Creates new file metadata record with the provided details
      operationId: createFileMetadata
      requestBody:
        content:
          application/json:
            schema:
              $ref: '#/components/schemas/CreateFilemetadataDto'
        required: true
      responses:
        "400":
          description: Invalid file metadata data
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "500":
          description: Internal server error
          content:
            '*/*':
              schema:
                $ref: '#/components/schemas/GenericHttpResponseFileMetadataResponse'
        "200":
          description: File metadata created successfully
          content:
            '*/*':
              schema:
                $ref: '#/components/schemas/GenericHttpResponseFileMetadataResponse'
  /v1/application:
    post:
      tags:
      - Application Management
      summary: Create new application
      description: Creates Rewards Engine Application for a Country
      operationId: create_6
      requestBody:
        content:
          application/json:
            schema:
              $ref: '#/components/schemas/CreateApplicationDto'
        required: true
      responses:
        "400":
          description: Bad Request
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Validation Error
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Successfully created application
          content:
            '*/*':
              schema:
                type: object
        "401":
          description: Unauthorized
          content:
            '*/*':
              schema:
                type: object
  /v1/application/run-cron/{cronJobName}:
    post:
      tags:
      - Application Management
      operationId: runCronJob
      parameters:
      - name: cronJobName
        in: path
        required: true
        schema:
          type: string
      responses:
        "400":
          description: Bad Request
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: OK
          content:
            '*/*':
              schema:
                type: object
  /v1/application/invoice-payload:
    post:
      tags:
      - Application Management
      operationId: processInvoicePayload
      requestBody:
        content:
          application/json:
            schema:
              type: object
              properties:
                applicationIdDto:
                  $ref: '#/components/schemas/ApplicationIdDto'
                orderInvoiceDto:
                  $ref: '#/components/schemas/OrderInvoiceDto'
        required: true
      responses:
        "400":
          description: Bad Request
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: OK
          content:
            '*/*':
              schema:
                type: object
  /v1/activities:
    get:
      tags:
      - Activity Configuration
      summary: Get Activity Config List
      description: Retrieve activities with pagination and filtering
      operationId: list_5
      parameters:
      - name: params
        in: query
        description: Listing parameters for filtering and pagination
        required: true
        schema:
          $ref: '#/components/schemas/ActivityConfigurationListingParamsDto'
      responses:
        "400":
          description: Bad Request
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Successfully retrieved activity list
          content:
            '*/*':
              schema:
                type: object
    post:
      tags:
      - Activity Configuration
      summary: Create new activity
      description: Creates a new activity configuration
      operationId: create_7
      requestBody:
        content:
          application/json:
            schema:
              $ref: '#/components/schemas/CreateActivityConfigDto'
        required: true
      responses:
        "400":
          description: Bad Request
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Successfully created activity configuration
          content:
            '*/*':
              schema:
                type: object
  /v1/activities/validate:
    post:
      tags:
      - Activity Configuration
      summary: Validate Activity Configuration Time Range
      description: Validates if activity configuration time range is valid
      operationId: validateTimeRange
      requestBody:
        content:
          application/json:
            schema:
              $ref: '#/components/schemas/ValidateActivityConfigDto'
        required: true
      responses:
        "400":
          description: Invalid validation data
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Validation completed
          content:
            '*/*':
              schema:
                type: object
  /v1/activities/validate-names:
    post:
      tags:
      - Activity Configuration
      summary: Validate Activity Configuration Title
      description: Validates if activity configuration title is unique and valid
      operationId: validateTitle
      requestBody:
        content:
          application/json:
            schema:
              $ref: '#/components/schemas/ValidateTitleActivityConfigDto'
        required: true
      responses:
        "400":
          description: Invalid title data
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Title validation completed
          content:
            '*/*':
              schema:
                type: object
  /v1/activities/v2/validate:
    post:
      tags:
      - Activity Configuration
      summary: Validate Activity Configuration Within Time Range (V2)
      description: Validates activity configuration within a specific time range
      operationId: validateActivityConfigWithinTimeRange
      requestBody:
        content:
          application/json:
            schema:
              $ref: '#/components/schemas/ValidateDateActivityConfigDto'
        required: true
      responses:
        "400":
          description: Invalid validation data
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Validation completed
          content:
            '*/*':
              schema:
                type: object
  /api/erp-categories/saveMultiple:
    post:
      tags:
      - ERP Category Mapping
      summary: Save multiple ERP categories
      description: Saves multiple ERP category mappings for products
      operationId: saveMultipleErpCategories
      requestBody:
        content:
          application/json:
            schema:
              $ref: '#/components/schemas/MultipleErpCategoriesDTO'
        required: true
      responses:
        "400":
          description: Invalid request data
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Successfully saved ERP categories
          content:
            '*/*':
              schema:
                type: string
        "500":
          description: Internal server error
          content:
            '*/*':
              schema:
                type: string
  /v1/users/{storeId}/goals/{goalId}:
    get:
      tags:
      - User Goals
      summary: Fetch User Goal by ID
      description: Retrieves a specific user goal by store ID and goal ID
      operationId: fetchUserGoalById
      parameters:
      - name: storeId
        in: path
        description: Store ID
        required: true
        schema:
          type: string
      - name: goalId
        in: path
        description: Goal ID to retrieve
        required: true
        schema:
          type: integer
          format: int32
      - name: body
        in: query
        description: Request parameters for goal retrieval
        required: true
        schema:
          $ref: '#/components/schemas/GetUserGoalRequestDto'
      responses:
        "400":
          description: Invalid request parameters
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Store or goal not found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Successfully retrieved user goal
          content:
            '*/*':
              schema:
                type: object
    patch:
      tags:
      - User Goals
      summary: Update Goal Opt-in Status
      description: Updates the opt-in status for a specific user goal
      operationId: updateUser
      parameters:
      - name: storeId
        in: path
        description: Store ID
        required: true
        schema:
          type: string
      - name: goalId
        in: path
        description: Goal ID to update
        required: true
        schema:
          type: integer
          format: int32
      requestBody:
        content:
          application/json:
            schema:
              $ref: '#/components/schemas/UpdateOptInStatusRequestDto'
        required: true
      responses:
        "400":
          description: Invalid request data
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Store or goal not found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Goal opt-in status updated successfully
          content:
            '*/*':
              schema:
                type: object
  /v1/file-metadata/{uuid}:
    get:
      tags:
      - File Metadata
      summary: View file metadata
      description: Retrieves file metadata information by UUID
      operationId: viewFileMetadata
      parameters:
      - name: uuid
        in: path
        description: UUID of the file metadata to retrieve
        required: true
        schema:
          type: string
      responses:
        "400":
          description: Invalid UUID format
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: File metadata not found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: File metadata retrieved successfully
          content:
            '*/*':
              schema:
                $ref: '#/components/schemas/GenericHttpResponseFileMetadataResponse'
        "500":
          description: Internal server error
          content:
            '*/*':
              schema:
                $ref: '#/components/schemas/GenericHttpResponseFileMetadataResponse'
    patch:
      tags:
      - File Metadata
      summary: Update file metadata
      description: Updates existing file metadata record by UUID
      operationId: updateFileMetadata
      parameters:
      - name: uuid
        in: path
        description: UUID of the file metadata to update
        required: true
        schema:
          type: string
      requestBody:
        content:
          application/json:
            schema:
              $ref: '#/components/schemas/UpdateFilemetadataDto'
        required: true
      responses:
        "400":
          description: Invalid file metadata data
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: File metadata not found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: File metadata updated successfully
          content:
            '*/*':
              schema:
                $ref: '#/components/schemas/GenericHttpResponseFileMetadataResponse'
        "500":
          description: Internal server error
          content:
            '*/*':
              schema:
                $ref: '#/components/schemas/GenericHttpResponseFileMetadataResponse'
  /v1/users/activities:
    get:
      tags:
      - User Activities
      summary: List user activities
      description: Retrieves a paginated list of user activities based on filtering
        parameters
      operationId: listing
      parameters:
      - name: data
        in: query
        description: Listing parameters for filtering and pagination
        required: true
        schema:
          $ref: '#/components/schemas/ListingParamsDto'
      responses:
        "400":
          description: Invalid request parameters
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable entity
          content:
            '*/*':
              schema:
                type: object
        "500":
          description: Internal server error
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: User activities retrieved successfully
          content:
            '*/*':
              schema:
                type: object
  /v1/tiers/{tierId}:
    get:
      tags:
      - Tiers
      summary: Get tier details by ID
      description: Retrieves detailed information for a specific tier by ID and status
      operationId: getTierDetails
      parameters:
      - name: country
        in: header
        description: Country code in ISO 3166-1 alpha-2 format
        required: true
        schema:
          pattern: "^[A-Z]{2}$"
          type: string
      - name: tierId
        in: path
        description: Tier ID to retrieve details for
        required: true
        schema:
          type: integer
          format: int32
      - name: status
        in: query
        description: Tier configuration status to filter by
        required: true
        schema:
          type: string
          enum:
          - PUBLISHED
          - DRAFT
      responses:
        "400":
          description: Invalid tier ID or status
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Tier not found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Tier details retrieved successfully
          content:
            '*/*':
              schema:
                type: object
        "500":
          description: Internal server error
          content:
            '*/*':
              schema:
                type: object
  /v1/tiers/{tierId}/stores:
    get:
      tags:
      - Tiers
      summary: Get tier stores
      description: Retrieves stores associated with a specific tier with pagination
        support
      operationId: getTierStores
      parameters:
      - name: country
        in: header
        required: false
        schema:
          pattern: "^[A-Z]{2}$"
          type: string
      - name: tierId
        in: path
        required: true
        schema:
          type: integer
          format: int32
      - name: updatedDate
        in: query
        required: false
        schema:
          type: string
          format: date
      - name: page
        in: query
        required: false
        schema:
          type: integer
          format: int32
      - name: limit
        in: query
        required: false
        schema:
          type: integer
          format: int32
      responses:
        "400":
          description: Invalid request parameters
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Tier not found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Tier stores retrieved successfully
          content:
            '*/*':
              schema:
                $ref: '#/components/schemas/TierStoresResponseDto'
  /v1/tiers/{tierId}/filtering-stores-by-store-id:
    get:
      tags:
      - Tiers
      operationId: searchTierStores
      parameters:
      - name: country
        in: header
        required: false
        schema:
          pattern: "^[A-Z]{2}$"
          type: string
      - name: tierId
        in: path
        required: true
        schema:
          type: integer
          format: int32
      - name: storeId
        in: query
        required: false
        schema:
          type: string
          default: ""
      - name: page
        in: query
        required: false
        schema:
          type: integer
          format: int32
      - name: limit
        in: query
        required: false
        schema:
          type: integer
          format: int32
      responses:
        "400":
          description: Bad Request
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: OK
          content:
            '*/*':
              schema:
                $ref: '#/components/schemas/TierStoresResponseDto'
  /v1/tiers/{tierId}/filtering-stores-by-date:
    get:
      tags:
      - Tiers
      operationId: filteringStoresByDate
      parameters:
      - name: country
        in: header
        required: false
        schema:
          pattern: "^[A-Z]{2}$"
          type: string
      - name: tierId
        in: path
        required: true
        schema:
          type: integer
          format: int32
      - name: filterDate
        in: query
        required: false
        schema:
          type: string
          default: ""
      - name: page
        in: query
        required: false
        schema:
          type: integer
          format: int32
      - name: limit
        in: query
        required: false
        schema:
          type: integer
          format: int32
      responses:
        "400":
          description: Bad Request
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: OK
          content:
            '*/*':
              schema:
                $ref: '#/components/schemas/TierStoresResponseDto'
  /v1/tiers/store-detail:
    get:
      tags:
      - Tiers
      summary: Get store tier details
      description: Retrieves tier details for a specific store
      operationId: getTierDetailsByStore
      parameters:
      - name: country
        in: header
        required: true
        schema:
          pattern: "^[A-Z]{2}$"
          type: string
      - name: storeId
        in: query
        required: true
        schema:
          type: string
      responses:
        "400":
          description: Invalid country format
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Store not found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Store tier details retrieved successfully
          content:
            '*/*':
              schema:
                $ref: '#/components/schemas/StoreTierDetailsDTO'
  /v1/tiers/name:
    get:
      tags:
      - Tiers
      summary: Get tier names by country
      description: Retrieves tier names filtered by country code
      operationId: getTierNames
      parameters:
      - name: country
        in: header
        description: Country code in ISO 3166-1 alpha-2 format
        required: true
        schema:
          pattern: "^[A-Z]{2}$"
          type: string
          default: MX
      responses:
        "400":
          description: Invalid country format
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: No tiers found for the specified country
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Tier names retrieved successfully
          content:
            '*/*':
              schema:
                type: object
        "500":
          description: Internal server error
          content:
            '*/*':
              schema:
                type: object
  /v1/template/types:
    get:
      tags:
      - Template Download
      summary: Get template types
      description: Retrieves a list of all available template types for download
      operationId: getTypes
      responses:
        "400":
          description: Bad Request
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Template types retrieved successfully
          content:
            '*/*':
              schema:
                type: object
        "500":
          description: Internal server error
          content:
            '*/*':
              schema:
                type: object
  /v1/reports/goal/{id}:
    get:
      tags:
      - Reports
      summary: Download goal report
      description: Generates and downloads a CSV report for the specified goal configuration
      operationId: downoadReport
      parameters:
      - name: id
        in: path
        description: Goal configuration ID
        required: true
        schema:
          type: integer
          format: int32
      responses:
        "400":
          description: Bad Request
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Goal configuration not found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: CSV report generated successfully
          content:
            '*/*':
              schema:
                type: string
        "500":
          description: Internal server error
          content:
            '*/*':
              schema:
                type: string
  /v1/points-multiplier/{id}/products-multiplier:
    get:
      tags:
      - Points Multiplier
      summary: Get products multiplier by ID
      description: Retrieves products and point multipliers for a specific points
        multiplier configuration
      operationId: listProductsPointMultiplier
      parameters:
      - name: id
        in: path
        description: Points multiplier ID to retrieve products for
        required: true
        schema:
          type: integer
          format: int32
      responses:
        "400":
          description: Invalid multiplier ID
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Points multiplier not found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Products multiplier retrieved successfully
          content:
            '*/*':
              schema:
                type: object
        "500":
          description: Internal server error
          content:
            '*/*':
              schema:
                type: object
  /v1/points-multiplier/types:
    get:
      tags:
      - Points Multiplier
      summary: Get points multiplier types
      description: Retrieves a list of all available points multiplier types
      operationId: getPointsMultiplierTypes
      responses:
        "400":
          description: Bad Request
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Points multiplier types retrieved successfully
          content:
            '*/*':
              schema:
                type: array
                items:
                  type: string
        "500":
          description: Internal server error
          content:
            '*/*':
              schema:
                type: array
                items:
                  type: string
  /v1/points-automation/list:
    get:
      tags:
      - Points Automation
      summary: List Points Automation (V2)
      description: Retrieves a paginated list of points automation configurations
        with enhanced data
      operationId: listPointsAutomation
      parameters:
      - name: params
        in: query
        description: Listing parameters for filtering and pagination
        required: true
        schema:
          $ref: '#/components/schemas/PointAutomationListingParamsDto'
      responses:
        "400":
          description: Bad Request
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Successfully retrieved configurations
          content:
            '*/*':
              schema:
                type: object
  /v1/oms/reward-details/{invoiceId}:
    get:
      tags:
      - OMS Integration
      summary: Get reward details by invoice
      description: Retrieves reward details for a specific invoice ID
      operationId: getRewardDetails
      parameters:
      - name: invoiceId
        in: path
        description: Invoice ID to retrieve reward details for
        required: true
        schema:
          type: string
      - name: applicationId
        in: query
        description: "Application ID (optional, uses default if not provided)"
        required: false
        schema:
          type: integer
          format: int32
      responses:
        "400":
          description: Invalid invoice ID
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Invoice not found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "500":
          description: Internal server error
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Reward details retrieved successfully
          content:
            '*/*':
              schema:
                type: object
  /v1/masters/activities:
    get:
      tags:
      - Activity Master
      summary: List activity masters
      description: Retrieves a paginated list of activity master data based on the
        provided filtering parameters
      operationId: list_2
      parameters:
      - name: params
        in: query
        description: Activity master listing parameters for filtering and pagination
        required: true
        schema:
          $ref: '#/components/schemas/ActivityMasterListingDto'
      responses:
        "400":
          description: Invalid request parameters
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Successfully retrieved activity masters
          content:
            '*/*':
              schema:
                type: object
        "500":
          description: Internal server error
          content:
            '*/*':
              schema:
                type: object
  /v1/goals/types:
    get:
      tags:
      - Goals
      summary: Get All Goal Types
      description: Returns a list of all available goal types
      operationId: getGoalTypes
      responses:
        "400":
          description: Bad Request
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Goal types retrieved successfully
          content:
            '*/*':
              schema:
                type: array
                items:
                  type: string
        "500":
          description: Internal server error
          content:
            '*/*':
              schema:
                type: array
                items:
                  type: string
  /v1/goals/summary:
    get:
      tags:
      - Goals
      summary: List goal summaries
      description: Retrieves a paginated list of goal configuration summaries
      operationId: list_3
      parameters:
      - name: params
        in: query
        description: Listing parameters for filtering and pagination
        required: true
        schema:
          $ref: '#/components/schemas/ActivityMasterListingDto'
      responses:
        "400":
          description: Invalid request parameters
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Goal summaries retrieved successfully
          content:
            '*/*':
              schema:
                type: object
        "500":
          description: Internal server error
          content:
            '*/*':
              schema:
                type: object
  /v1/goals/names:
    get:
      tags:
      - Goals
      summary: Retrieve goals by Name
      description: Searches for goals matching the specified name
      operationId: fetchGoalConfigByName
      parameters:
      - name: params
        in: query
        description: Goal configuration name-based request parameters
        required: true
        schema:
          $ref: '#/components/schemas/GoalConfigByNameRequestListingDto'
      responses:
        "400":
          description: Invalid request parameters
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: No goals found with specified name
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "500":
          description: Internal server error
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Goal configurations retrieved successfully
          content:
            '*/*':
              schema:
                type: object
  /v1/fileshare/download/**:
    get:
      tags:
      - File Share
      summary: Download file
      description: Downloads a file from the server based on the file path provided
        in the URL
      operationId: downloadTemplate
      responses:
        "400":
          description: Invalid file path or bad request
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: File not found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: File downloaded successfully
          content:
            '*/*':
              schema:
                type: string
                format: binary
        "500":
          description: Internal server error
          content:
            '*/*':
              schema:
                type: string
                format: binary
  /v1/dropdownmaster:
    get:
      tags:
      - Dropdown Master
      summary: Get all dropdown values
      description: Retrieves all dropdown values for form fields throughout the application
      operationId: getAllDropdownValues
      responses:
        "400":
          description: Bad Request
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Successfully retrieved dropdown values
          content:
            '*/*':
              schema:
                type: object
                additionalProperties:
                  type: object
        "500":
          description: Internal server error
          content:
            '*/*':
              schema:
                type: object
                additionalProperties:
                  type: object
  /v1/activitytypes:
    get:
      tags:
      - Activity Types
      summary: Get activity types
      description: Retrieves a list of all available activity type enumerations
      operationId: getActivityTypes
      responses:
        "400":
          description: Bad Request
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Successfully retrieved activity types
          content:
            '*/*':
              schema:
                type: array
                items:
                  type: string
        "500":
          description: Internal server error
          content:
            '*/*':
              schema:
                type: array
                items:
                  type: string
  /v1/activitymaster:
    get:
      tags:
      - Activity Logs
      summary: List activity logs
      description: Retrieves a paginated list of activity logs based on the provided
        filtering parameters
      operationId: list_4
      parameters:
      - name: params
        in: query
        description: Activity master listing parameters for filtering and pagination
        required: true
        schema:
          $ref: '#/components/schemas/ActivityMasterListingDto'
      responses:
        "400":
          description: Invalid request parameters
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Successfully retrieved activity logs
          content:
            '*/*':
              schema:
                type: object
        "500":
          description: Internal server error
          content:
            '*/*':
              schema:
                type: object
  /v1/activities-names:
    get:
      tags:
      - Activity Names
      summary: Get activities by country
      description: Retrieves a list of activity names filtered by country code
      operationId: getActivitiesByCountry
      parameters:
      - name: country
        in: header
        description: "Country code in ISO 3166-1 alpha-2 format (e.g., US, GB)"
        required: true
        schema:
          pattern: "^[A-Z]{2}$"
          type: string
          default: MX
      responses:
        "400":
          description: Invalid country format
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "500":
          description: Internal server error
          content:
            '*/*':
              schema:
                type: array
                items:
                  $ref: '#/components/schemas/ActivityNameResponseDto'
        "200":
          description: Successfully retrieved activity names
          content:
            '*/*':
              schema:
                type: array
                items:
                  $ref: '#/components/schemas/ActivityNameResponseDto'
  /testroute:
    get:
      tags:
      - Default
      summary: Test route
      description: Simple health check endpoint that returns 'ok' status
      operationId: testroute
      responses:
        "400":
          description: Bad Request
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Not Found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Test route is working correctly
          content:
            '*/*':
              schema:
                type: string
        "500":
          description: Internal server error
          content:
            '*/*':
              schema:
                type: string
  /public/{filename}:
    get:
      tags:
      - Public Files
      summary: Download public file
      description: Downloads a publicly accessible file by filename
      operationId: downloadPublicFile
      parameters:
      - name: filename
        in: path
        description: Name of the file to download
        required: true
        schema:
          type: string
      responses:
        "400":
          description: Invalid filename
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: File not found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: File downloaded successfully
          content:
            '*/*':
              schema:
                type: string
                format: binary
        "500":
          description: Internal server error
          content:
            '*/*':
              schema:
                type: string
                format: binary
  /api/erp-categories/get/{productId}:
    get:
      tags:
      - ERP Category Mapping
      summary: Get ERP category by product ID
      description: Retrieves the ERP category mapping for a specific product ID
      operationId: getErpCategoryByProductId
      parameters:
      - name: productId
        in: path
        description: Product ID to retrieve ERP category for
        required: true
        schema:
          type: string
      responses:
        "400":
          description: Invalid product ID format
          content:
            '*/*':
              schema:
                type: object
        "404":
          description: Product ID not found
          content:
            '*/*':
              schema:
                type: object
        "422":
          description: Unprocessable Entity
          content:
            '*/*':
              schema:
                type: object
        "200":
          description: Successfully retrieved ERP category
          content:
            '*/*':
              schema:
                type: string
        "500":
          description: Internal server error
          content:
            '*/*':
              schema:
                type: string
components:
  schemas:
    DollarSpendRule:
      required:
      - excludedCategories
      - excludedProductIds
      - includedCategories
      - includedProductIds
      type: object
      properties:
        includedCategories:
          uniqueItems: true
          type: array
          items:
            type: string
        includedProductIds:
          uniqueItems: true
          type: array
          items:
            type: string
        excludedCategories:
          uniqueItems: true
          type: array
          items:
            type: string
        excludedProductIds:
          uniqueItems: true
          type: array
          items:
            type: string
    DollarSpendRuleSet:
      required:
      - includeAllProductsByDefault
      - rules
      - skipNonAssorted
      type: object
      properties:
        name:
          type: string
        rules:
          maxItems: 2147483647
          minItems: 1
          type: array
          items:
            $ref: '#/components/schemas/DollarSpendRule'
        includeAllProductsByDefault:
          type: boolean
        skipNonAssorted:
          type: boolean
    GoalDto:
      required:
      - applicationId
      - displayEndDate
      - displayStartDate
      - endDate
      - name
      - startDate
      - targetEndDate
      - type
      - userGoalsFileUrl
      type: object
      properties:
        applicationId:
          type: integer
          format: int32
        userGoalsFileUrl:
          type: string
        name:
          type: string
        ruleSet:
          $ref: '#/components/schemas/DollarSpendRuleSet'
        type:
          type: string
        pointDisplay:
          type: string
        awardInstantly:
          type: boolean
        rewardDate:
          type: string
          format: date-time
        requiresOptIn:
          type: boolean
        vatIncluded:
          type: boolean
        cepRefId:
          type: integer
          format: int32
        roundOffValue:
          type: number
          format: double
        tasks:
          type: array
          items:
            type: integer
            format: int32
        startDate:
          type: string
          format: date-time
        endDate:
          type: string
          format: date-time
        targetEndDate:
          type: string
          format: date-time
        displayStartDate:
          type: string
          format: date-time
        displayEndDate:
          type: string
          format: date-time
        imageUrls:
          type: array
          items:
            $ref: '#/components/schemas/GoalImageDto'
        translations:
          type: object
          additionalProperties:
            type: object
            additionalProperties:
              type: string
        metadata:
          type: object
          additionalProperties:
            type: object
        ignoreSkuList:
          type: boolean
        offlineOrdersIncluded:
          type: boolean
        child:
          $ref: '#/components/schemas/GoalDto'
        updatedBy:
          type: string
      description: Goal configuration details to create
    GoalImageDto:
      type: object
      properties:
        cepRefId:
          type: string
        id:
          type: string
        index:
          type: string
        optIn:
          type: string
        title:
          type: string
        language:
          type: string
        filename:
          type: string
        imageUrl:
          type: string
        excerpt:
          type: string
        terms:
          type: string
    UpdateGoalDto:
      required:
      - applicationId
      - displayEndDate
      - displayStartDate
      - endDate
      - startDate
      - targetEndDate
      type: object
      properties:
        applicationId:
          type: integer
          format: int32
        userGoalsFileUrl:
          type: string
        ruleSet:
          $ref: '#/components/schemas/DollarSpendRuleSet'
        type:
          type: string
        pointDisplay:
          type: string
        awardInstantly:
          type: boolean
        rewardDate:
          type: string
          format: date-time
        requiresOptIn:
          type: boolean
        vatIncluded:
          type: boolean
        roundOffValue:
          type: number
          format: double
        cepRefId:
          type: integer
          format: int32
        startDate:
          type: string
          format: date-time
        endDate:
          type: string
          format: date-time
        targetEndDate:
          type: string
          format: date-time
        displayStartDate:
          type: string
          format: date-time
        displayEndDate:
          type: string
          format: date-time
        imageUrls:
          type: array
          items:
            $ref: '#/components/schemas/GoalImageDto'
        translations:
          type: object
          additionalProperties:
            type: object
            additionalProperties:
              type: string
        metadata:
          type: object
          additionalProperties:
            type: object
        child:
          $ref: '#/components/schemas/GoalDto'
        offlineOrdersIncluded:
          type: boolean
      description: Updated goal configuration details
    UpdateRewardEngineUserDto:
      required:
      - applicationId
      type: object
      properties:
        email:
          type: string
        phone:
          type: string
        status:
          type: string
          enum:
          - ACTIVE
          - INACTIVE
          - UNREGISTERED
        applicationId:
          type: integer
          format: int32
      description: Updated user data
    DollarSpendItem:
      required:
      - assorted
      - category
      - confirmedQty
      - name
      type: object
      properties:
        name:
          type: string
        category:
          type: string
        price:
          type: number
          format: float
        vatExcludedPrice:
          type: number
          format: float
        assorted:
          type: boolean
        confirmedQty:
          type: number
          format: float
        uniqueId:
          type: string
          format: uuid
    UserGoalInvoiceDto:
      required:
      - channelName
      - dateTime
      - invoiceNumber
      - items
      - totalAmount
      - totalAmountVatExcluded
      - totalQuantity
      type: object
      properties:
        items:
          maxItems: 2147483647
          minItems: 1
          uniqueItems: true
          type: array
          items:
            $ref: '#/components/schemas/DollarSpendItem'
        totalAmount:
          type: number
          format: double
        totalQuantity:
          type: number
          format: float
        totalAmountVatExcluded:
          type: number
          format: double
        channelName:
          type: string
        invoiceNumber:
          type: string
        dateTime:
          type: string
          format: date-time
        sourceSystemName:
          type: string
        acknowledgementType:
          type: string
        sourceAcknowledgementId:
          type: string
        sourceSystemId:
          type: string
        referenceInvoiceId:
          type: string
    UserGoalUpdateRequestDto:
      required:
      - applicationId
      - invoice
      type: object
      properties:
        userId:
          type: integer
          format: int32
        invoice:
          $ref: '#/components/schemas/UserGoalInvoiceDto'
        applicationId:
          type: integer
          format: int32
        storeId:
          type: string
        giveDeliveryPoints:
          type: boolean
      description: Goal update data
    CreateRewardDto:
      required:
      - applicationId
      - name
      - status
      type: object
      properties:
        id:
          type: integer
          format: int32
        applicationId:
          type: integer
          format: int32
        name:
          type: string
        status:
          type: string
        rewardType:
          type: string
        digitalCodeAmount:
          type: number
          format: double
        digitalCodePartner:
          type: string
        redeemPoints:
          type: number
          format: double
        loyaltyUrl:
          type: string
        rewardProducts:
          type: array
          items:
            $ref: '#/components/schemas/RewardProductDto'
        digitalCodes:
          type: array
          items:
            $ref: '#/components/schemas/DigitalCodeDto'
        cardType:
          type: string
        rewardCashAmount:
          type: number
          format: double
        orderQty:
          type: integer
          format: int32
        limitOfProductQty:
          type: integer
          format: int32
        discountAmount:
          type: number
          format: double
        allCustomers:
          type: boolean
        includedSegmentGroups:
          type: array
          items:
            $ref: '#/components/schemas/IncludedSegmentGroupDto'
        segmentExclude:
          type: boolean
        excludedSegments:
          type: array
          items:
            $ref: '#/components/schemas/Segment'
        defaultImage:
          type: boolean
        imageUrls:
          type: array
          items:
            type: string
        alertDisplayCount:
          type: integer
          format: int32
        rewardText:
          type: object
          additionalProperties:
            $ref: '#/components/schemas/TextDetail'
        startDate:
          type: string
          format: date-time
        endDate:
          type: string
          format: date-time
        displayOutOfStock:
          type: boolean
        inStock:
          type: boolean
        limitPerStore:
          type: integer
          format: int32
        quota:
          type: integer
          format: int32
        leftOverInventory:
          type: integer
          format: int32
        maxQtyPerOrder:
          type: integer
          format: int32
        unlimitedInventory:
          type: boolean
        updatedBy:
          type: string
      description: Reward data to create
    DigitalCodeDto:
      type: object
      properties:
        id:
          type: integer
          format: int32
        codeId:
          type: integer
          format: int32
        customerId:
          type: string
        used:
          type: boolean
        startDate:
          type: string
          format: date-time
        endDate:
          type: string
          format: date-time
        referenceNo:
          type: string
        url:
          type: string
    IncludedSegmentGroupDto:
      type: object
      properties:
        segments:
          type: array
          items:
            $ref: '#/components/schemas/Segment'
    RewardProductDto:
      type: object
      properties:
        id:
          type: integer
          format: int32
        productId:
          type: string
        productName:
          type: string
        priority:
          type: integer
          format: int32
        productPoints:
          type: integer
          format: int32
        unlimitedQuota:
          type: boolean
        productQuota:
          type: integer
          format: int32
        productInventory:
          type: integer
          format: int32
    Segment:
      type: object
      properties:
        segmentId:
          type: string
        segmentName:
          type: string
    TextDetail:
      type: object
      properties:
        title:
          type: string
        description:
          type: string
    ViewRewardDto:
      type: object
      properties:
        id:
          type: integer
          format: int32
        applicationId:
          type: integer
          format: int32
        name:
          type: string
        status:
          type: string
        rewardType:
          type: string
        defaultImage:
          type: boolean
        imageUrls:
          type: array
          items:
            type: string
        alertDisplayCount:
          type: integer
          format: int32
        rewardText:
          type: object
          additionalProperties:
            $ref: '#/components/schemas/TextDetail'
        displayOutOfStock:
          type: boolean
        inStock:
          type: boolean
        leftOverInventory:
          type: integer
          format: int32
        maxQtyPerOrder:
          type: integer
          format: int32
        unlimitedInventory:
          type: boolean
        digitalCodeAmount:
          type: number
          format: double
        digitalCodePartner:
          type: string
        redeemPoints:
          type: number
          format: double
        loyaltyUrl:
          type: string
        rewardProducts:
          type: array
          items:
            $ref: '#/components/schemas/RewardProductDto'
        digitalCodes:
          type: array
          items:
            $ref: '#/components/schemas/DigitalCodeDto'
        startDate:
          type: string
          format: date-time
        endDate:
          type: string
          format: date-time
        cardType:
          type: string
        rewardCashAmount:
          type: number
          format: double
        limitPerStore:
          type: integer
          format: int32
        quota:
          type: integer
          format: int32
        orderQty:
          type: integer
          format: int32
        limitOfProductQty:
          type: integer
          format: int32
        discountAmount:
          type: number
          format: double
        allCustomers:
          type: boolean
        includedSegmentGroups:
          type: array
          items:
            $ref: '#/components/schemas/IncludedSegmentGroupDto'
        segmentExclude:
          type: boolean
        excludedSegments:
          type: array
          items:
            $ref: '#/components/schemas/Segment'
        createdAt:
          type: string
          format: date-time
        updatedAt:
          type: string
          format: date-time
        createdBy:
          type: string
        updatedBy:
          type: string
    UpdatePointAutomationDto:
      required:
      - action
      - schedule
      - scheduledAt
      - type
      type: object
      properties:
        importFile:
          type: string
        name:
          type: string
        schedule:
          type: string
        scheduledAt:
          type: string
          format: date-time
        type:
          type: string
        cepRefId:
          type: integer
          format: int32
        action:
          type: string
        noOfDays:
          type: integer
          format: int32
        pointsToModify:
          type: number
          format: double
      description: Updated points automation data
    UpdateImportFileRequestDto:
      required:
      - fileUrl
      type: object
      properties:
        fileUrl:
          type: string
      description: Import file details for updating user goals
    ApplicationConfigDto:
      type: object
      properties:
        languages:
          type: array
          items:
            type: string
        currency:
          type: string
        preferences:
          $ref: '#/components/schemas/Preferences'
        getoverAchievingTargets:
          type: array
          items:
            type: string
    PointsMultiplierRule:
      required:
      - multiplier
      - name
      type: object
      properties:
        name:
          type: string
        matchWith:
          type: array
          items:
            type: string
        multiplier:
          type: number
          format: double
    PointsMultiplierRuleSet:
      required:
      - rules
      type: object
      properties:
        rules:
          maxItems: 2147483647
          minItems: 1
          type: array
          items:
            $ref: '#/components/schemas/PointsMultiplierRule'
    Preferences:
      type: object
      properties:
        targetSpendType:
          type: string
    UpdateApplicationDto:
      type: object
      properties:
        timezone:
          type: string
        pointsMultiplierRuleSet:
          $ref: '#/components/schemas/PointsMultiplierRuleSet'
        config:
          $ref: '#/components/schemas/ApplicationConfigDto'
      description: Updated application data
    UpdateActivityConfigDto:
      required:
      - limitFrequency
      - maxLimitPerUser
      - points
      type: object
      properties:
        points:
          type: number
          format: double
        maxLimitPerUser:
          type: integer
          format: int32
        limitFrequency:
          type: integer
          format: int32
        conversionRate:
          type: number
          format: double
        tags:
          type: string
        name:
          type: string
          enum:
          - WELCOME
          - LOGIN
          - PLAY_GAME
          - WATCH_VIDEO
          - SURVEY
          - POINTS_TRANSFER
          - PRODUCT_PURCHASE
          - PROMOTIONAL_POINTS
          - REDEEM_POINTS
          - POINTS_AUTOMATION
          - MANUAL_ADD
          - MANUAL_REMOVE
          - REFUND_POINTS
          - SALES_TARGET
          - GENERIC_ACTIVITY
        amountPerUnit:
          type: number
          format: double
        pointsAwardedPerUnit:
          type: number
          format: double
        title:
          type: string
        allowPointsToBeOverriden:
          type: boolean
        maximumEarnablePoints:
          type: number
          format: double
        requireUniqueIdentifier:
          type: boolean
        activeStartDate:
          type: string
          format: date-time
        activeEndDate:
          type: string
          format: date-time
        allTimeLimit:
          type: integer
          format: int32
        orderType:
          type: string
        localCurrency:
          type: string
        scheduledPointDeliveryTime:
          type: string
      description: Updated activity configuration data
    RewardEngineUserDto:
      required:
      - applicationId
      - storeId
      type: object
      properties:
        id:
          type: integer
          format: int32
        storeId:
          type: string
        email:
          type: string
        phone:
          type: string
        applicationId:
          type: integer
          format: int32
      description: User data to create
    UpdateUserSegmentsDto:
      required:
      - segments
      type: object
      properties:
        storeId:
          type: string
        segments:
          type: array
          items:
            type: string
      description: User segment configuration data
    CreateUserActivityDto:
      required:
      - applicationId
      - slug
      type: object
      properties:
        storeId:
          type: string
        applicationId:
          type: integer
          format: int32
        slug:
          type: string
        data:
          $ref: '#/components/schemas/UserActivityRequestDto'
      description: User activity details to record
    UserActivityRequestDto:
      type: object
      properties:
        saleValue:
          type: number
          format: double
        transferPoints:
          type: number
          format: double
        redeemPoints:
          type: number
          format: double
        rewardPoints:
          type: number
          format: double
        transferTo:
          type: string
        source:
          type: string
        remarks:
          type: string
    UpdateMultipleUserSegmentsDto:
      required:
      - segments
      - storeIds
      type: object
      properties:
        storeIds:
          type: array
          items:
            type: string
        segments:
          type: array
          items:
            type: string
      description: Multiple user segment configurations to create
    Activity:
      required:
      - id
      - multiplier
      type: object
      properties:
        id:
          type: integer
          format: int32
        multiplier:
          type: number
    LanguageContent:
      required:
      - bannerHeader
      - bannerImage
      - descriptionDetail
      - detailsImage
      - imageTierIcon
      - tierName
      type: object
      properties:
        tierName:
          type: string
        displayDescription:
          type: string
        imageTierIcon:
          type: string
        bannerHeader:
          type: string
        bannerDescription:
          type: string
        bannerImage:
          type: string
        descriptionDetail:
          type: string
        termsAndConditions:
          type: string
        detailsImage:
          type: string
    TierRequest:
      required:
      - activities
      - content
      - status
      type: object
      properties:
        tierId:
          type: integer
          format: int32
        status:
          type: string
          enum:
          - PUBLISHED
          - DRAFT
        activities:
          type: array
          items:
            $ref: '#/components/schemas/Activity'
        content:
          type: object
          additionalProperties:
            $ref: '#/components/schemas/LanguageContent'
      description: Tier configuration request data
    TierPostResponse:
      type: object
      properties:
        configId:
          type: string
        message:
          type: string
        field:
          type: string
    MoveStoresRequest:
      required:
      - newTierID
      - storeIds
      type: object
      properties:
        newTierID:
          minimum: 1
          type: integer
          format: int32
        storeIds:
          type: array
          items:
            type: string
    TiersStoresUpdateResponseDto:
      type: object
      properties:
        message:
          type: string
        alerts:
          type: array
          items:
            type: string
    TiersStoreRequestDto:
      required:
      - storeIds
      - tierId
      type: object
      properties:
        storeIds:
          type: array
          items:
            type: string
        tierId:
          type: integer
          format: int32
      description: Tier stores upload request containing tier ID and store IDs
    TemplateDownloadParams:
      required:
      - applicationId
      - type
      type: object
      properties:
        applicationId:
          type: integer
          format: int32
        type:
          type: string
        levels:
          type: integer
          format: int32
        mileStones:
          type: integer
          format: int32
        addStores:
          type: boolean
        tierId:
          type: integer
          format: int32
      description: Template download parameters including type and configuration
    CreatePointMultiplierDto:
      required:
      - applicationId
      - multiplierValue
      - name
      - rulesCriteria
      - rulesCriteriaValue
      - rulesPriority
      - startDate
      - status
      type: object
      properties:
        applicationId:
          type: integer
          format: int32
        name:
          type: string
        rulesCriteria:
          type: string
        rulesCriteriaValue:
          type: string
        rulesPriority:
          minimum: 1
          type: integer
          format: int32
        multiplierValue:
          type: string
        startDate:
          type: string
          format: date-time
        endDate:
          type: string
          format: date-time
        status:
          type: string
        productMappingDtoList:
          type: array
          items:
            $ref: '#/components/schemas/ProductMultiplierDto'
        metadata:
          type: object
          additionalProperties:
            type: object
      description: Points multiplier configuration to create
    ProductMultiplierDto:
      required:
      - pointMultiplier
      - productId
      type: object
      properties:
        id:
          type: integer
          format: int32
        productId:
          type: string
        pointMultiplier:
          type: string
    NameValidationRequestDto:
      required:
      - applicationId
      - name
      type: object
      properties:
        name:
          type: string
        applicationId:
          type: integer
          format: int32
    CreatePointAutomationDto:
      required:
      - action
      - applicationId
      - schedule
      - scheduledAt
      - type
      type: object
      properties:
        applicationId:
          type: integer
          format: int32
        importFile:
          type: string
        name:
          type: string
        schedule:
          type: string
        scheduledAt:
          type: string
          format: date-time
        type:
          type: string
        cepRefId:
          type: integer
          format: int32
        action:
          type: string
        noOfDays:
          type: integer
          format: int32
        pointsToModify:
          type: number
          format: double
      description: Points automation data to create
    EstimatePointsRequestDto:
      type: object
      properties:
        internalTotalPrice:
          type: number
          format: double
        quantity:
          type: number
          format: double
      description: Order data for points estimation
    CreateFilemetadataDto:
      required:
      - applicationId
      - expectedCount
      - fileName
      - fileSize
      - fileType
      - status
      - storageContainer
      - storagePath
      - templateType
      - uuid
      type: object
      properties:
        uuid:
          pattern: "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-4[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$"
          type: string
        applicationId:
          minimum: 1
          type: integer
          format: int32
        expectedCount:
          minimum: 1
          type: integer
          format: int32
        fileName:
          type: string
        fileSize:
          minimum: 1
          type: integer
          format: int64
        fileType:
          type: string
        status:
          type: string
          enum:
          - DRAFT
          - PUBLISHED
          - COMPLETED
          - DELETED
          - PARTIAL_SUCCESS
        storageContainer:
          type: string
        storagePath:
          type: string
        importStartDate:
          type: string
          format: date-time
        importEndDate:
          type: string
          format: date-time
        templateType:
          type: string
          enum:
          - SALES_TARGET
        createdBy:
          type: string
      description: File metadata details to create
    FileMetadataResponse:
      type: object
      properties:
        id:
          type: integer
          format: int32
        applicationId:
          type: integer
          format: int32
        goalConfigId:
          type: integer
          format: int32
        uuid:
          type: string
        status:
          type: string
        expectedCount:
          type: integer
          format: int32
        completedCount:
          type: integer
          format: int32
        erroredCount:
          type: integer
          format: int32
        fileName:
          type: string
        fileSize:
          type: integer
          format: int64
        fileType:
          type: string
        importStartDate:
          type: string
          format: date-time
        importEndDate:
          type: string
          format: date-time
        uploadDate:
          type: string
          format: date-time
        storageContainer:
          type: string
        storagePath:
          type: string
        templateType:
          type: string
        createdBy:
          type: string
        updatedBy:
          type: string
        createdAt:
          type: string
          format: date-time
        updatedAt:
          type: string
          format: date-time
    GenericHttpResponseFileMetadataResponse:
      type: object
      properties:
        success:
          type: boolean
        message:
          type: string
        data:
          $ref: '#/components/schemas/FileMetadataResponse'
    CreateApplicationDto:
      required:
      - country
      - pointsMultiplierRuleSet
      - siteId
      - timezone
      type: object
      properties:
        country:
          type: string
        siteId:
          type: string
        timezone:
          type: string
        config:
          $ref: '#/components/schemas/ApplicationConfigDto'
        pointsMultiplierRuleSet:
          $ref: '#/components/schemas/PointsMultiplierRuleSet'
      description: Application configuration data
    ApplicationIdDto:
      required:
      - applicationId
      type: object
      properties:
        applicationId:
          type: integer
          format: int32
    AcknowledgedOrderDto:
      type: object
      properties:
        id:
          type: string
        items:
          type: array
          items:
            $ref: '#/components/schemas/ItemDto'
        sourceOrderId:
          type: string
        netTotalAmount:
          type: number
          format: double
        totalGrossAmount:
          type: number
          format: double
        totalDiscountAmount:
          type: number
          format: double
        totalTaxAmount:
          type: number
          format: double
        soldToCustomerId:
          type: string
        sourceSystemName:
          type: string
        referenceInvoiceId:
          type: string
    ItemDto:
      type: object
      properties:
        materialId:
          type: string
        totalNetAmount:
          type: number
          format: double
        totalGrossAmount:
          type: number
          format: float
        totalDiscountAmount:
          type: number
          format: float
        totalTaxAmount:
          type: number
          format: float
        confirmedQty:
          type: number
          format: float
        requestedQty:
          type: number
          format: float
        unitPriceAmount:
          type: number
          format: float
        freeFlag:
          type: string
    OrderInvoiceDto:
      type: object
      properties:
        id:
          type: string
        createdDateTime:
          type: string
          format: date-time
        acknowledgedOrder:
          $ref: '#/components/schemas/AcknowledgedOrderDto'
        acknowledgementType:
          type: string
        sourceAcknowledgementId:
          type: string
        sourceSystemId:
          type: string
    CreateActivityConfigDto:
      required:
      - applicationId
      - limitFrequency
      - maxLimitPerUser
      - name
      - points
      - slug
      - tags
      type: object
      properties:
        applicationId:
          type: integer
          format: int32
        name:
          type: string
          enum:
          - WELCOME
          - LOGIN
          - PLAY_GAME
          - WATCH_VIDEO
          - SURVEY
          - POINTS_TRANSFER
          - PRODUCT_PURCHASE
          - PROMOTIONAL_POINTS
          - REDEEM_POINTS
          - POINTS_AUTOMATION
          - MANUAL_ADD
          - MANUAL_REMOVE
          - REFUND_POINTS
          - SALES_TARGET
          - GENERIC_ACTIVITY
        tags:
          type: string
        slug:
          maxLength: 200
          minLength: 0
          pattern: "[^ ]+"
          type: string
        points:
          type: number
          format: double
        maxLimitPerUser:
          type: integer
          format: int32
        limitFrequency:
          type: integer
          format: int32
        conversionRate:
          type: number
          format: double
        amountPerUnit:
          type: number
          format: double
        pointsAwardedPerUnit:
          type: number
          format: double
        title:
          type: string
        allowPointsToBeOverriden:
          type: boolean
        maximumEarnablePoints:
          type: number
          format: double
        requireUniqueIdentifier:
          type: boolean
        activeStartDate:
          type: string
          format: date-time
        activeEndDate:
          type: string
          format: date-time
        allTimeLimit:
          type: integer
          format: int32
        orderType:
          type: string
        localCurrency:
          type: string
        updatedBy:
          type: string
        scheduledPointDeliveryTime:
          type: string
      description: Activity configuration data to create
    ValidateActivityConfigDto:
      required:
      - activeEndDate
      - activeStartDate
      - name
      type: object
      properties:
        name:
          type: string
          enum:
          - WELCOME
          - LOGIN
          - PLAY_GAME
          - WATCH_VIDEO
          - SURVEY
          - POINTS_TRANSFER
          - PRODUCT_PURCHASE
          - PROMOTIONAL_POINTS
          - REDEEM_POINTS
          - POINTS_AUTOMATION
          - MANUAL_ADD
          - MANUAL_REMOVE
          - REFUND_POINTS
          - SALES_TARGET
          - GENERIC_ACTIVITY
        activeStartDate:
          type: string
          format: date-time
        activeEndDate:
          type: string
          format: date-time
      description: Activity configuration validation data
    ValidateTitleActivityConfigDto:
      required:
      - applicationId
      - title
      type: object
      properties:
        id:
          type: integer
          format: int32
        applicationId:
          type: integer
          format: int32
        title:
          type: string
      description: Title validation data
    ValidateDateActivityConfigDto:
      required:
      - activeStartDate
      - applicationId
      - name
      - title
      type: object
      properties:
        id:
          type: integer
          format: int32
        applicationId:
          type: integer
          format: int32
        name:
          type: string
          enum:
          - WELCOME
          - LOGIN
          - PLAY_GAME
          - WATCH_VIDEO
          - SURVEY
          - POINTS_TRANSFER
          - PRODUCT_PURCHASE
          - PROMOTIONAL_POINTS
          - REDEEM_POINTS
          - POINTS_AUTOMATION
          - MANUAL_ADD
          - MANUAL_REMOVE
          - REFUND_POINTS
          - SALES_TARGET
          - GENERIC_ACTIVITY
        activeStartDate:
          type: string
          format: date-time
        activeEndDate:
          type: string
          format: date-time
        orderType:
          type: string
        title:
          type: string
      description: Date-based activity configuration validation data
    ErpCategoryData:
      required:
      - erpCategory
      - productMaterialId
      type: object
      properties:
        productMaterialId:
          pattern: \d+
          type: string
        erpCategory:
          pattern: "^[A-Za-z0-9 \\-_&]+$"
          type: string
    MultipleErpCategoriesDTO:
      type: object
      properties:
        rows:
          type: array
          items:
            $ref: '#/components/schemas/ErpCategoryData'
      description: Multiple ERP categories data to be saved
    UpdateOptInStatusRequestDto:
      required:
      - applicationId
      type: object
      properties:
        applicationId:
          type: integer
          format: int32
        goalId:
          type: integer
          format: int32
        userId:
          type: integer
          format: int32
        optInStatus:
          type: boolean
        storeId:
          type: string
      description: Opt-in status update data
    UpdateFilemetadataDto:
      required:
      - goalConfigId
      - status
      type: object
      properties:
        status:
          type: string
          enum:
          - DRAFT
          - PUBLISHED
          - COMPLETED
          - DELETED
          - PARTIAL_SUCCESS
        goalConfigId:
          type: integer
          format: int32
        updatedBy:
          type: string
      description: Updated file metadata details
    RewardEngineUserListingDto:
      required:
      - applicationId
      type: object
      properties:
        id:
          type: integer
          format: int32
        storeId:
          type: string
        page:
          type: integer
          format: int32
        limit:
          type: integer
          format: int32
        applicationId:
          minimum: 1
          type: integer
          format: int32
    GetUserGoalRequestDto:
      type: object
      properties:
        applicationId:
          type: integer
          format: int32
        userId:
          type: integer
          format: int32
        storeId:
          type: string
        goalId:
          type: integer
          format: int32
        page:
          type: integer
          format: int32
        offset:
          type: integer
          format: int32
        limit:
          type: integer
          format: int32
    UserSegmentsRequestDto:
      type: object
      properties:
        storeId:
          type: string
    ListingParamsDto:
      required:
      - applicationId
      type: object
      properties:
        limit:
          maximum: 200
          type: integer
          format: int32
        page:
          type: integer
          format: int32
        offset:
          type: integer
          format: int32
        from:
          type: string
        to:
          type: string
        order:
          type: string
        activityType:
          type: string
        storeId:
          type: string
        month:
          type: string
        applicationId:
          type: integer
          format: int32
    TierGetActivityResponse:
      type: object
      properties:
        activityID:
          type: integer
          format: int32
        activityName:
          type: string
        multiplier:
          type: number
    TierGetResponse:
      type: object
      properties:
        tierID:
          type: integer
          format: int32
        name:
          type: string
        color:
          type: string
        country:
          type: string
        status:
          type: string
          enum:
          - PUBLISHED
          - DRAFT
        active:
          type: boolean
        lastUpdated:
          type: string
          format: date-time
        storesAssociated:
          type: integer
          format: int32
        activities:
          type: array
          items:
            $ref: '#/components/schemas/TierGetActivityResponse'
    PaginationDto:
      type: object
      properties:
        currentPage:
          type: integer
          format: int32
        totalPages:
          type: integer
          format: int32
        totalStores:
          type: integer
          format: int64
    StoreDto:
      type: object
      properties:
        storeId:
          type: string
        lastModifiedDate:
          type: string
          format: date-time
    TierStoresResponseDto:
      type: object
      properties:
        tierID:
          type: integer
          format: int32
        stores:
          type: array
          items:
            $ref: '#/components/schemas/StoreDto'
        pagination:
          $ref: '#/components/schemas/PaginationDto'
    ActivitiesStoreResponse:
      type: object
      properties:
        tierActivityId:
          type: integer
          format: int32
        activityConfigId:
          type: integer
          format: int32
        multiplier:
          type: number
    BannerStore:
      type: object
      properties:
        imageUrl:
          type: string
        name:
          type: string
        header:
          type: string
        description:
          type: string
    ClubPlusDetails:
      type: object
      properties:
        detailsImage:
          type: string
        description:
          type: string
        termsAndConditions:
          type: string
    LanguageStoreContent:
      type: object
      properties:
        tierImageUrl:
          type: string
        tierName:
          type: string
        tierDescription:
          type: string
        banner:
          $ref: '#/components/schemas/BannerStore'
        clubPlusDetails:
          $ref: '#/components/schemas/ClubPlusDetails'
    StoreTierDetailsDTO:
      type: object
      properties:
        tierId:
          type: integer
          format: int32
        color:
          type: string
        customerId:
          type: string
        activities:
          type: array
          items:
            $ref: '#/components/schemas/ActivitiesStoreResponse'
        languages:
          type: object
          additionalProperties:
            $ref: '#/components/schemas/LanguageStoreContent'
    RewardCatalogRequestDto:
      required:
      - page
      - size
      type: object
      properties:
        applicationId:
          type: integer
          format: int32
        page:
          type: integer
          format: int32
        size:
          type: integer
          format: int32
    RewardCatalogItemDto:
      type: object
      properties:
        name:
          type: string
        type:
          type: string
        rewardId:
          type: integer
          format: int32
        availableInventory:
          type: integer
          format: int32
        totalInventory:
          type: integer
          format: int32
        unlimitedInventory:
          type: boolean
        rewardAcceptance:
          type: integer
          format: int32
        startDate:
          type: string
        endDate:
          type: string
        updatedDate:
          type: string
        updatedBy:
          type: string
        status:
          type: string
    RewardCatalogResponseDtoRewardCatalogItemDto:
      type: object
      properties:
        totalRecords:
          type: integer
          format: int64
        totalPages:
          type: integer
          format: int32
        pageSize:
          type: integer
          format: int32
        currentPage:
          type: integer
          format: int32
        items:
          type: array
          items:
            $ref: '#/components/schemas/RewardCatalogItemDto'
    ListPointMultiplierRequestDto:
      required:
      - limit
      - page
      type: object
      properties:
        limit:
          type: integer
          format: int32
        page:
          type: integer
          format: int32
        applicationId:
          type: integer
          format: int32
        id:
          type: integer
          format: int32
        name:
          type: string
        sort:
          type: string
    PointAutomationListingParamsDto:
      required:
      - limit
      - page
      type: object
      properties:
        limit:
          type: integer
          format: int32
        page:
          type: integer
          format: int32
        applicationId:
          type: integer
          format: int32
        id:
          type: integer
          format: int32
        sort:
          type: string
        name:
          type: string
    ActivityMasterListingDto:
      required:
      - applicationId
      - id
      - limit
      - page
      type: object
      properties:
        applicationId:
          type: integer
          format: int32
        limit:
          type: integer
          format: int32
        page:
          type: integer
          format: int32
        orderBy:
          type: string
        order:
          type: string
        id:
          type: integer
          format: int32
    GoalConfigRequestListingDto:
      required:
      - limit
      - page
      type: object
      properties:
        applicationId:
          type: integer
          format: int32
        id:
          type: integer
          format: int32
        name:
          type: string
        limit:
          type: integer
          format: int32
        page:
          type: integer
          format: int32
    GoalConfigByIdRequestListingDto:
      type: object
      properties:
        id:
          type: integer
          format: int32
        page:
          type: integer
          format: int32
        limit:
          type: integer
          format: int32
    GoalConfigByNameRequestListingDto:
      type: object
      properties:
        applicationId:
          type: integer
          format: int32
        name:
          type: string
        page:
          type: integer
          format: int32
        limit:
          type: integer
          format: int32
    ActivityConfigurationListingParamsDto:
      required:
      - limit
      - page
      type: object
      properties:
        limit:
          type: integer
          format: int32
        page:
          type: integer
          format: int32
        id:
          type: integer
          format: int32
        applicationId:
          type: integer
          format: int32
        slug:
          type: string
        title:
          type: string
        name:
          type: string
    ActivityNameResponseDto:
      type: object
      properties:
        id:
          type: integer
          format: int32
        name:
          type: string
  securitySchemes:
    oktaOAuth:
      type: oauth2
      flows:
        authorizationCode:
          authorizationUrl: https:///pepsico.oktapreview.com/oauth2/default/v1/authorize
          tokenUrl: https:///pepsico.oktapreview.com/oauth2/default/v1/token
          scopes:
            openid: OpenId connect scope
            profile: Access profile info
            email: Access email info
`;